import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { PorfolioItem, portfolioItems } from '../../../data/portfolio-items';

import { ServiceType } from '@/data/service-items';
import { translate } from '@/translations';

export const PortfolioListSection = () => {
  const { t } = useTranslation('portfolio');
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState<ServiceType>(ServiceType.all);
  const allCategories = [
    ServiceType.all,
    ...new Set(portfolioItems.flatMap((portfolioItem) => portfolioItem.categories)),
  ];

  const showDetails = (item: PorfolioItem) => {
    navigate(`/portfolio/${item.key}`);
  };

  const filteredItems = portfolioItems.filter(
    (item) => selectedCategory === ServiceType.all || item.categories.includes(selectedCategory)
  );

  return (
    <>
      <div className="section bg-dark text-white">
        <div className="flex justify-center">
          <div className="2xl:w-4/6">
            <div className="flex items-start text-base md:text-lg overflow-x-auto max-w-[100vw]">
              {allCategories.map((category) => (
                <button
                  key={category}
                  className={`hover:text-hoverButton uppercase px-4 py-2 rounded-lg border-1 border-white text-nowrap ${selectedCategory === category ? 'bg-hoverButton hover:text-dark text-dark font-semibold' : ''}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {translate(`serviceItems:${category}:title`)}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="flex justify-center mt-24">
          <div className="2xl:w-4/6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 my-10 mx-10">
              {filteredItems.map((item, index) => (
                <div key={index} className="cursor-pointer p-8" onClick={() => showDetails(item)}>
                  <div className="flex justify-center">
                    <img
                      src={item.thumbnailSrc}
                      className="rounded-xl object-cover h-[40vh]"
                      alt={item.title}
                      loading="lazy"
                    />
                  </div>

                  <div className="flex justify-between items-start mt-5">
                    <div className="text-base md:text-lg font-semibold">
                      <h1>{t(item.title)}</h1>
                    </div>
                    <div className="text-sm md:text-base">
                      <div className="flex items-center">
                        {t('viewNow')}
                        &nbsp;
                        <FaChevronRight />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-5 mt-2">
                    {item.icons.map((icon, index) => (
                      <div className="flex items-center gap-2" key={index}>
                        <img
                          src={icon.img}
                          className="size-8"
                          alt="Technology icon"
                          loading="lazy"
                        />
                        <p className="text-white/60 whitespace-nowrap text-xs">{icon.caption}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
